import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_MEDIUM_SCREEN_850 } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrExternalLink from 'client/components/SrExternalLink';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';

import './SrHelpCard.less';

const SrHelpCard = ({ imageUrl, title, linkUrl }) => {
  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN_850,
  });

  return (
    <SrExternalLink link={linkUrl} styleName="SrHelpCard">
      <SrBox
        backgroundColor="white"
        borderRadius="14px"
        boxShadow="0px 15px 26px rgba(212, 212, 212, 0.17)"
        padding="18px 0 27px"
        cursor="pointer"
        height="100%"
        boxSizing="border-box"
      >
        <SrBox
          width="100%"
          height="122px"
          backgroundSize="contain"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
          backgroundImage={`url(${imageUrl})`}
          marginBottom="9px"
        />
        <SrFlex
          align="center"
          justify="center"
          width="100%"
          padding="0 16px"
          boxSizing="border-box"
        >
          <SrText
            font="greycliff"
            size="21"
            lineHeight="25px"
            color="blueGreycliff"
            weight="800"
            align="center"
          >
            {title}
          </SrText>
          {!isMediumScreen && (
            <SrBox margin="4px 0 0 13px">
              <SrIcon className="arrow-right-blue-large" />
            </SrBox>
          )}
        </SrFlex>
      </SrBox>
    </SrExternalLink>
  );
};

SrHelpCard.propTypes = {
  imageUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
};

SrHelpCard.displayName = 'SrHelpCard';

export default SrHelpCard;
